import { useIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';

export default function SupplierList({
  children = null,
  suppliers = [],
  loading = false,
  onAddSupplier,
  onRemoveSupplier,
}) {
  let history = useHistory();
  const intl = useIntl();

  const onClick = (e, supplierId) => {
    const target = e.target;
    if (target.tagName === 'BUTTON' || target.tagName === 'A') {
      return;
    }
    history.push(`/supplier/${supplierId}/`);
  };

  const onRemove = (e, supplier) => {
    e.stopPropagation();
    onRemoveSupplier(supplier);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-start mb-8">
        <h2 className="text-nowrap">
          {intl.formatMessage({ id: 'suppliers.listTitle' })}
        </h2>
        <div className="d-flex gap-4 flex-wrap flex-row-reverse w-100">
          <button onClick={onAddSupplier} className="btn btn-primary">
            <span className="fa fa-plus me-2" />
            {intl.formatMessage({ id: 'suppliers.addNewSupplier' })}
          </button>
        </div>
      </div>
      {children && <div className="row mb-8">{children}</div>}
      {loading && <div className="spinner-border text-primary" role="status" />}
      {!loading && suppliers.length === 0 && (
        <p>{intl.formatMessage({ id: 'suppliers.noSuppliers' })}</p>
      )}
      {!loading && suppliers.length > 0 && (
        <div className="table-responsive">
          <table className="table table-hover table-row-dashed table-row-gray-200 align-start gs-0 gy-4">
            <thead className="table-header sticky-top bg-white fw-bolder">
              <tr className="">
                <th className="ps-2">
                  {intl.formatMessage({ id: 'suppliers.id' })}
                </th>
                <th>{intl.formatMessage({ id: 'suppliers.name' })}</th>
                <th>{intl.formatMessage({ id: 'suppliers.vatNumber' })}</th>
                <th>{intl.formatMessage({ id: 'suppliers.email' })}</th>
                <th>{intl.formatMessage({ id: 'suppliers.phone' })}</th>
                <th>{intl.formatMessage({ id: 'suppliers.createdAt' })}</th>
                <th>{intl.formatMessage({ id: 'suppliers.view' })}</th>
                <th className="pe-2">
                  {intl.formatMessage({ id: 'suppliers.remove' })}
                </th>
              </tr>
            </thead>
            <tbody className="text-left">
              {suppliers
                ?.sort((a, b) => b.id - a.id)
                ?.map((supplier, index) => (
                  <tr
                    className="cursor-pointer"
                    key={index}
                    onClick={(e) => onClick(e, supplier.id)}
                  >
                    <td className="ps-2">{supplier.id}</td>
                    <td>{supplier.name}</td>
                    <td>{supplier.vat_number}</td>
                    <td>{supplier.email || '-'}</td>
                    <td>{supplier.phone || '-'}</td>
                    <td>
                      {supplier.created_at
                        ? new Date(supplier.created_at).toLocaleDateString(
                            intl.locale,
                            {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                            }
                          )
                        : '-'}
                    </td>
                    <td>
                      <Link
                        to={`/supplier/${supplier.id}/`}
                        className="btn btn-sm btn-tertiary fa fa-eye text-primary py-0"
                      />
                    </td>
                    <td className="pe-2">
                      <button
                        onClick={(e) => onRemove(e, supplier)}
                        className="btn btn-sm btn-tertiary fa fa-trash text-danger py-0"
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
